export default __webpack_public_path__ + "static/media/Le Grand Toscano .74b839cc.jpg";